import { Button, Form, FormInstance, Input, Image } from "antd";
import { useEffect } from "react";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import UploadImage from "../../components/UploadImage";

interface getConnetedProps {
  heading?: string;
  subtext?: string;
  buttonLabel?: string;
  image?: string;
}
interface Props {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: FormInstance;
  getConnected?: getConnetedProps;
  loading?: boolean;
}

const GetConnected: React.FC<Props> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  getConnected,
  loading,
}) => {
  useEffect(() => {
    if (getConnected) {
      form.setFieldsValue({
        getConnected: {
          heading: getConnected?.heading || "",
          subtext: getConnected?.subtext || "",
          buttonLabel: getConnected?.buttonLabel || "Get Connected",
          image: getConnected?.image || "",
        },
      });
    } else {
      form.setFieldsValue({
        getConnected: {
          heading: "",
          subtext: "",
          buttonLabel: "Get Connected",
          image: "",
        },
      });
    }
  }, [getConnected, form]);
  return (
    <>
      <div>
        {!isEditing ? (
          <>
            <div className="hidden sm:block rounded-[20px] overflow-hidden">
              <table className="min-w-full">
                <thead>
                  <tr className="bg-primary text-white">
                    <th className="py-3 px-4 text-left">Image</th>
                    <th className="py-3 px-4 text-left">Heading</th>
                    <th className="py-3 px-4 text-left">Subtext</th>
                    {/* <th className="py-3 px-4 text-left">Button Label</th> */}
                    <th className="py-3 px-4 text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {getConnected ? (
                    <tr className="bg-[#F9F9F9] border-b">
                      <td className="py-3 px-4">
                        <Image
                          src={getConnected?.image}
                          height={50}
                          width={120}
                          className="object-cover rounded-md max-h-[80px]"
                          alt="Get Connected"
                        />
                      </td>
                      <td className="py-3 px-4">
                        {getConnected?.heading || "—"}
                      </td>
                      <td className="py-3 px-4">
                        {getConnected?.subtext || "—"}
                      </td>
                      {/* <td className="py-3 px-4">
                        {getConnected?.buttonLabel || "—"}
                      </td> */}

                      <td className="py-3 px-4 text-right text-primary">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer text-[20px]"
                        />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center py-6">
                        <Button
                          type="dashed"
                          onClick={() => setIsEditing(true)}
                        >
                          Add Data
                        </Button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="sm:hidden space-y-3">
              {getConnected ? (
                <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-2">
                  <p>
                    <b className="text-primary">Heading:</b> <div>{getConnected?.heading}</div>
                  </p>
                  <p>
                    <b className="text-primary">Subtext:</b> <div>{getConnected?.subtext}</div>
                  </p>
                  {/* <p>
                    <b>Button Label:</b> <div>{getConnected?.buttonLabel}</div>
                  </p> */}
                  <p>
                    <b className="text-primary">Image:</b>
                    <div>
                      <Image src={getConnected?.image} width={160} />
                    </div>
                  </p>

                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-[20px] text-primary"
                  />
                </div>
              ) : (
                <div>
                  <div className="text-center py-6">
                    <Button type="dashed" onClick={() => setIsEditing(true)}>
                      Add Data
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div>
            <div className="bg-[#F9F9F9] p-4 rounded-lg">
              <Form layout="vertical" form={form}>
                <Form.Item
                  label="Heading"
                  name={["getConnected", "heading"]}
                  rules={[{ required: true, message: "Please enter heading" }]}
                >
                  <Input placeholder="Heading" />
                </Form.Item>

                <Form.Item
                  label="Subtext"
                  name={["getConnected", "subtext"]}
                  rules={[{ required: true, message: "Please enter subtext" }]}
                >
                  <TextArea rows={3} placeholder="Enter subtext..." />
                </Form.Item>
                <Form.Item
                  label="Button Label"
                  name={["getConnected", "buttonLabel"]}
                >
                  <Input placeholder="enter label..." />
                </Form.Item>

                <Form.Item
                  label="Image"
                  name={["getConnected", "image"]}
                  rules={[{ required: true }]}
                >
                  <UploadImage listType="picture-card" />
                </Form.Item>
              </Form>
            </div>

            <div className="flex gap-3 mt-6">
              <ButtonWrapper
                type="primary"
                onClick={handleSave}
                loading={loading}
              >
                Save
              </ButtonWrapper>
              <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default GetConnected;
